import type { ILocalePreference } from "@/types/localeTypes";

const STORAGE_KEY = "mci-wiki-locale-preference";

export function getLocalePreference(): ILocalePreference | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored) as ILocalePreference;
    }

    const sessionStored = sessionStorage.getItem(STORAGE_KEY);
    if (sessionStored) {
      return JSON.parse(sessionStored) as ILocalePreference;
    }

    return null;
  } catch (error) {
    console.error("Error reading locale preference:", error);
    return null;
  }
}

export function setLocalePreference(localeCode: string): boolean {
  const preference: ILocalePreference = {
    localeCode,
    selectedAt: new Date().toISOString(),
    storageType: "localStorage",
  };

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(preference));
    return true;
  } catch {
    try {
      preference.storageType = "sessionStorage";
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(preference));
      return true;
    } catch {
      return false;
    }
  }
}

export function clearLocalePreference(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Silently fail if storage unavailable
  }
}
